import React from 'react';
import { Descriptions, Spin } from 'antd';
import getFormattedValue from 'store/redux/utils/getFormattedValue';

const UrlCostPreview = ({ previewData, isLoading }) => {
  const items = [
    {
      key: 'daily_cost',
      label: 'Daily Cost',
      children: getFormattedValue(previewData?.daily_cost, previewData?.currency),
    },
    {
      key: 'total_cost',
      label: 'Total Cost',
      children: getFormattedValue(previewData?.total_cost, previewData?.currency),
    },
  ];

  if (isLoading) {
    return (
      <div className='flex justify-center items-center h-full my-4'>
        <Spin />
      </div>
    );
  }

  if (!previewData) return null;

  return <Descriptions layout='vertical' bordered items={items} size='small' className='mt-5' />;
};

export default UrlCostPreview;
